export const getLatestPickupTime = ({
    toHour,
    toMinute,
    showPickupUntilExactClosingTime,
}: {
    toHour: number;
    toMinute: number;
    showPickupUntilExactClosingTime: boolean;
}) => {
    const MINUTES_BEFORE_CLOSING_TIME = 15;
    const MINUTES_IN_HOUR = 60;

    if (showPickupUntilExactClosingTime) {
        return {latestPickupHour: toHour, latestPickupMinute: toMinute};
    }

    const latestPickupHour = toMinute < MINUTES_BEFORE_CLOSING_TIME ? toHour - 1 : toHour;
    const latestPickupMinute =
        toMinute < MINUTES_BEFORE_CLOSING_TIME
            ? MINUTES_IN_HOUR + toMinute - MINUTES_BEFORE_CLOSING_TIME
            : toMinute - MINUTES_BEFORE_CLOSING_TIME;

    return {latestPickupHour, latestPickupMinute};
};
